import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  set(key: string, value: string): LocalStorageService {
    localStorage.setItem(key, value);

    return this;
  }

  get(key: string) {
    return localStorage.getItem(key);
  }

  remove(key: string): LocalStorageService {
    localStorage.removeItem(key);
    return this;
  }

  getObject(key: string): any {
    return JSON.parse(localStorage[key] || '{}');
  }
}
